import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import TreeItem from './TreeItem';
import { TreeManagementValue } from '../utils';
import FieldContainer from './FieldContainer';

const Tree = ({vardef, defaultValue, onChange}) =>
{
	const [firstLoad, SetFirstLoad] = useState(true);
	const [name, SetName] = useState('');
	const [collapsed, SetCollapsed] = useState(false);
	const [searchString, SetSearchString] = useState('');
	const [data, SetData] = useState(vardef.options ? vardef.options : []);
	// const data = vardef.options ? vardef.options : [];

	useEffect(() =>
	{
		if(vardef.options && !data.length)
		{
			SetData(vardef.options);
		}
	// eslint-disable-next-line
	}, [vardef]);

	useEffect(() =>
	{
		if(vardef.options)
		{
			SetData(Filter(vardef.options, searchString));
		}
	// eslint-disable-next-line
	}, [searchString]);
	
	useEffect(() =>
	{
		if(firstLoad && defaultValue && data && data.length)
		{
			SetName(TreeManagementValue(data, defaultValue));
			SetFirstLoad(false);
		}
	// eslint-disable-next-line
	}, [defaultValue]);

	const HandleChange = (value) =>
	{
		SetName(value?.name ?? '');
		SetCollapsed(true);
		if(onChange)
		{
			onChange(value?.id ?? '');
		}
	}

	function Filter(treeData, query)
	{
		return query ? treeData.reduce((acc, item) =>
		{
		 	if( item.children?.length )
			{
				const filtered = Filter(item.children, query)
				if( filtered.length )
				{
					return [...acc, {...item, children:filtered}];
				}
			}
			const {children, ...itemWithoutChildren} = item;
			return item.name?.toLowerCase().includes(query.toLowerCase()) ? [...acc, itemWithoutChildren] : acc   
		},[]) : treeData
	}
	return <div className='relative'>
		<Modal handler={<input readOnly type='text' className='form-control cursor-pointer' value={name}/>} fallDown={collapsed} onClose={() => SetCollapsed(false)}>
			<FieldContainer className={'w-full'} label={'جستجو'}><input type='text' onChange={(e) => SetSearchString(e.target.value)}/></FieldContainer>
			<ul className='hierarchy'>
			{data && data.length ? data.map((item, index) => <TreeItem key={index} data={item} expanded={searchString.length ? true : false} callback={(value) => HandleChange(value)}/>) : 'هیچ گزینه ای یافت نشد.'}
			</ul>
		</Modal>
		{name?.length ? <i className='fa fa-trash-alt absolute left-3 top-4 text-base cursor-pointer hover:text-danger' onClick={() => HandleChange({id: '', name:''})}></i> : null}
	</div>
};

export default Tree;